export default __webpack_public_path__ + "static/media/Path3399.00f69ff1.svg";